// extracted by mini-css-extract-plugin
export default {"LocalModeBanner":"LocalModeBanner_LocalModeBanner__iNbEc","text":"LocalModeBanner_text__3gJ28","missing":"LocalModeBanner_missing__-h-Ph","dismiss":"LocalModeBanner_dismiss__W5Zu3"};